var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { EPaymentRepetitionType } from "../types/payment.types";
export var NO_CONTINUOUS_VALUE = -1;
// One group per contract, keyed on a live recurring payment order of that
// contract. A broker edit soft-deletes the order and creates a new one, but
// older payment requests keep pointing at the deleted order, which then fails
// the payer guard on update-mandate (403) and no longer carries the live
// mandate. So every item of every request is considered, deleted orders are
// skipped, and the newest request with a live order of the contract wins.
// One-off orders (a late payment penalty, a single extra charge) are skipped
// too: each has a payment group of its own, so saving a mandate on one would
// switch that one-off group and leave the contract's recurring collection
// untouched. A contract without a recurring live order in the fetched requests
// has nothing to collect continuously, so it gets no group.
export var getContractMandateGroups = function (paymentRequests) {
    var groupsByContractId = new Map();
    // In the order the contracts were first seen, so the result is stable.
    var groups = [];
    paymentRequests.forEach(function (paymentRequest) {
        var _a;
        (_a = paymentRequest.paymentRequestItems) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
            var _b, _c;
            var paymentOrder = _a.paymentOrder;
            if (!(paymentOrder === null || paymentOrder === void 0 ? void 0 : paymentOrder.contractId) ||
                paymentOrder.deletedAt != null ||
                paymentOrder.repetitionType === EPaymentRepetitionType.Once) {
                return;
            }
            var contractId = paymentOrder.contractId;
            // The requests come newest first, so the first order of a contract wins.
            if (groupsByContractId.has(contractId)) {
                return;
            }
            var group = {
                contractId: contractId,
                paymentOrderId: paymentOrder.id,
                activeBankAccountId: (_c = (_b = paymentOrder.mandate) === null || _b === void 0 ? void 0 : _b.bankaccountId) !== null && _c !== void 0 ? _c : NO_CONTINUOUS_VALUE,
            };
            groupsByContractId.set(contractId, group);
            groups.push(group);
        });
    });
    return groups;
};
export var compareContractIds = function (a, b) {
    if (a === b) {
        return 0;
    }
    return a < b ? -1 : 1;
};
// The groups come out in the order of the newest payment requests, so a new
// request (the invitation worker at 10:25) moved a contract to the top and the
// tenant pressed Save on the wrong block. The order now only depends on the
// contracts themselves: start date first, contract id when two contracts start
// on the same day. A contract whose details are not loaded yet goes last.
export var sortContractMandateGroups = function (groups, contractsById) {
    return __spreadArray([], groups, true).sort(function (a, b) {
        var _a, _b;
        var startA = (_a = contractsById[a.contractId]) === null || _a === void 0 ? void 0 : _a.startDate;
        var startB = (_b = contractsById[b.contractId]) === null || _b === void 0 ? void 0 : _b.startDate;
        if (startA != null && startB != null) {
            var difference = new Date(startA).getTime() - new Date(startB).getTime();
            if (difference !== 0) {
                return difference;
            }
        }
        else if (startA != null || startB != null) {
            return startA != null ? -1 : 1;
        }
        return compareContractIds(a.contractId, b.contractId);
    });
};
